<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'Sntp Config'" style="height: 410px">
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in sntpClientConfig"
              :key="row.status"
              :class="{ 'true:': true }"
            >
              <td>
                <div>{{ row.status }}</div>
              </td>
              <td>
                <div>{{ row.mode }}</div>
              </td>
              <td>
                <div>{{ row.server }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!--配置操作-->
        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Sntp Config Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="status"
                  >Sntp Client</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="status"
                    v-model="sntpClientForm.status"
                  >
                    <option label="enable" value="1"></option>
                    <option label="disable" value="0"></option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="mode">Mode</label>
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="mode"
                    v-model="sntpClientForm.mode"
                    :disabled="sntpClientForm.status == '0'"
                  >
                    <option label="anycast" value="anycast"></option>
                    <option label="broadcast" value="broadcast"></option>
                    <option label="multicast" value="multicast"></option>
                    <option label="unicast" value="unicast"></option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="server"
                  >Sntp Server</label
                >
                <div
                  class="col-sm-5"
                  :class="{ 'has-error': input_para_check(1) }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="server"
                    v-model="sntpClientForm.server"
                    placeholder="A.B.C.D"
                    autocomplete="off"
                    :disabled="sntpClientForm.status == '0'"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: input_para_check(1) ? 'block' : 'none',
                    }"
                    >{{ input_para_check(1) }}
                  </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "sntpConfig",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: "",
      sntpClientConfig: "",
      isShowAddTable: false,
      iBox: {},
      sntpClientForm: {
        status: "",
        mode: "",
        server: "",
      },
    }
  },

  created() {
    this.loadSntpClientConfig()
  },

  methods: {
    loadSntpClientConfig() {
      get("sntpClient")
        .then((res) => {
          console.log(res)
          this.title = res.data.title
          this.sntpClientConfig = res.data.data
        })
        .catch((err) => {})
    },

    clkEdit() {
      if (this.sntpClientConfig[0].status == "enable") {
        this.sntpClientForm.status = "1"
      } else {
        this.sntpClientForm.status = "0"
      }
      this.sntpClientForm.mode = this.sntpClientConfig[0].mode
      this.sntpClientForm.server = this.sntpClientConfig[0].server
      this.isShowAddTable = true
      return
    },

    clkCancel() {
      this.isShowAddTable = false
    },

    clkApply() {
      var sntpClientConfig = {
        status: Number(this.sntpClientForm.status),
        mode: this.sntpClientForm.mode,
        server: this.sntpClientForm.server,
      }

      var msg = this.input_para_check(0)
      if (msg != null) {
        this.showAlertBox("warn", "Message", msg)
        return
      }

      if (this.sntpClientForm.status == "") {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }

      post("sntpClientConfig", sntpClientConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadSntpClientConfig()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
    },

    input_para_check(value) {
      if (value == 1 || value == 0) {
        if (this.sntpClientForm.server != "") {
          if (
            this.sntpClientForm.server.match(
              /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/
            ) == null
          ) {
            return "ip address must be inputted with A.B.C.D "
          } else {
            var id = this.sntpClientForm.server.split(".")
            let ip0 = Number(id[0])
            let ip1 = Number(id[1])
            let ip2 = Number(id[2])
            let ip3 = Number(id[3])
            if (
              ip0 < 0 ||
              ip0 > 255 ||
              ip1 < 0 ||
              ip1 > 255 ||
              ip2 < 0 ||
              ip2 > 255 ||
              ip3 < 0 ||
              ip3 > 255 ||
              (ip0 == 0 && ip1 == 0 && ip2 == 0 && ip3 == 0)
            )
              return "invalid ip address"
          }
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
